module.exports = __webpack_public_path__ + "img/Girl_030018.5be31d1a.png";